import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function notificationPermission() {
  return "Notification" in window ? Notification.permission : "unsupported";
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/service-worker.js");
  } catch (e) {
    return null;
  }
}

export async function isPushEnabled() {
  if (!pushSupported()) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub && Notification.permission === "granted";
  } catch (e) {
    return false;
  }
}

export async function enablePushNotifications() {
  if (!pushSupported()) {
    return { ok: false, error: "Notifications is device/browser par supported nahi hai. iPhone par pehle 'Add to Home Screen' karein." };
  }
  await registerServiceWorker();
  const reg = await navigator.serviceWorker.ready;
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, error: "Permission denied — settings me notifications allow karein." };
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.configured || !data.public_key) return { ok: false, error: "Server par push configured nahi hai." };
  try {
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.public_key),
      });
    }
    const json = sub.toJSON();
    await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys, user_agent: navigator.userAgent });
    return { ok: true };
  } catch (err) {
    return { ok: false, error: "Subscription nahi ban payi — phone par dobara try karein (browser settings me notifications allow ho)." };
  }
}

export async function disablePushNotifications() {
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg && (await reg.pushManager.getSubscription());
    if (sub) {
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
      await sub.unsubscribe();
    }
  } catch (e) { /* ignore */ }
  return { ok: true };
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test");
  return data;
}
